import React, { Component } from "react";
import Doughnut from "./../../shared/Doughnut";
import Contentify from "../../../content/Contentify";
import { connect } from "react-redux";
import Store from "./../../../content/Store";
import formatCurrencyAmount from "../../../helpers/FormatCurrencyAmount";

export const mapStateToWhatYouHaveUsedSection = (state) => {
  return {
    ExcessDetails:
      state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails
        .ExcessDetails
  };
};

const sharedLegendColours = [
  { color: "#fad6de" },
  { color: "#a6d5f1" },
  { color: "#fcd385" }
];

export const createChartOptionsForExcess = (excessDetails, content) => {
  const remainingAmount =
    excessDetails.Limit -
    (excessDetails.AmountUsedForThisInvoice +
      excessDetails.AmountUsedInOtherInvoices);

  return {
    legendColor: sharedLegendColours,
    data: [
      {
        key:
          content.ExcessSectionAmountUsedAcrossOtherPayments +
          formatCurrencyAmount(excessDetails.AmountUsedInOtherInvoices),
        value: excessDetails.AmountUsedInOtherInvoices,
        color: sharedLegendColours[0].color
      },
      {
        key:
          content.ExcessSectionUsedThisTime +
          formatCurrencyAmount(excessDetails.AmountUsedForThisInvoice),
        value: excessDetails.AmountUsedForThisInvoice,
        color: sharedLegendColours[1].color
      },
      {
        key:
          content.ExcessSectionRemaining +
          formatCurrencyAmount(remainingAmount),
        value: remainingAmount,
        color: sharedLegendColours[2].color
      }
    ]
  };
};

export class WhatYouHaveUsedSection extends Component {
  static content = Store.PaymentDetails.whatYouHaveUsedSection;
  render() {
    const excessChartOptions = createChartOptionsForExcess(
      this.props.ExcessDetails,
      this.props.content
    );
    const header = <h2 id="header">{this.props.content.Header}</h2>;
    const excessSection = (
      <div id="excessDoughnutSection">
        <p id="excessSubHeader">
          {this.props.content.ExcessSectionDescription}
        </p>
        <p id="excessDoughnutDesc">
          {this.props.content.ExcessSectionDoughnutTitleText}
          {formatCurrencyAmount(this.props.ExcessDetails.Limit)}
        </p>
        <Doughnut
          data={excessChartOptions.data}
          legendColorConfig={excessChartOptions.legendColor}
          centreValue={formatCurrencyAmount(this.props.ExcessDetails.Limit)}
        />
      </div>
    );

    return (
      <div className={this.props.className}>
        {header}
        {excessSection}
      </div>
    );
  }
}

export default connect(mapStateToWhatYouHaveUsedSection)(
  Contentify(WhatYouHaveUsedSection)
);
